import React from 'react';
import styled from 'styled-components';

const SelectionIndicator: React.FC<
  React.HTMLProps<HTMLDivElement>
> = styled.div.attrs({
  className: 'absolute bg-blue-2'
})`
  bottom: 0;
  height: 5px;
  left: 0;
  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #00aed9;
  }
`;

export default SelectionIndicator;
